module.exports = __webpack_public_path__ + "img/login-v2-dark.5fc82c6a.svg";